import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import "./Assets/scss/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Config } from "./config/Config";
import Layout from "./components/Layout/Layout";
import ToastDefault from "./components/Layout/Toast";
import { publicRoutes } from "./router/public.route";
import { privateRoutes } from "./router/private.route";
import PrivateRoute from "./router/PrivateRoutes";
import PageNotFound from "./pages/PageNotFound";
import { Suspense } from "react";
import Spinner from "./components/Spinner";

const App = () => {
  return (
    <>
      <Router basename={Config?.BASE_URL}>
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route element={<PrivateRoute component={Layout} />}>
              {privateRoutes?.map((route, routeKey) => {
                return (
                  <Route
                    path={route?.path}
                    element={route?.element}
                    key={routeKey}
                  />
                );
              })}
            </Route>

            <Route>
              {publicRoutes?.map((route: any, routeKey: any) => {
                return (
                  <Route
                    path={route?.path}
                    element={route?.element}
                    key={routeKey}
                  />
                );
              })}
            </Route>

            <Route path={"*"} element={<PageNotFound />}></Route>
            {/* <Route path={'/page-not-found'} element={<PageNotFound to="page-not-found" />}></Route> */}
          </Routes>
        </Suspense>
      </Router>
      <ToastDefault />
    </>
  );
};

export default App;
